<template>
  <v-dialog v-model="open" max-width="720" persistent>
    <v-card>
      <v-sheet color="grey lighten-2" elevation="1">
        <v-card-title class="d-flex justify-space-between">
          <div >
            <span class="headline">Lista de desejos</span>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="red"
                class="white--text"
                elevation="1"
                small
                @click="closeFavoritesForm()"
              >
                <v-icon dark>close</v-icon>
              </v-btn>
            </template>
            <span>Fechar</span>
          </v-tooltip>
        </v-card-title>
      </v-sheet>

      <v-container>
        <v-sheet min-height="100" color="transparent">
          <v-col class="py-2" v-for="(item) in immobileFavoritesList" :key="item.id" xs12 ms12 md4 lg3 xl2>
            <v-list-item :to="'/informacoes_imovel#' + item.id">
              <ImmobileCardFavorites :immobileInfo="item" />
            </v-list-item>
          </v-col>
        </v-sheet>
        <v-spacer class="pt-12"></v-spacer>
        <v-card>
          <v-card-title>
            Informações de contato
          </v-card-title>
          <v-card-text>

            <v-layout row wrap justify-start align-start>
              <p>
                <v-icon color="blue">place</v-icon>
                {{ contacStreet }} {{ contacNumber }}, {{ contacDistrict }}, {{ contacCity }}/{{ contacState }} CEP {{ contacZip }}
              </p>
            </v-layout>
            <v-layout row wrap justify-start>
              <v-img src="@/assets/icons/whatsapp.png" max-width="24" min-width="24" max-height="24" min-height="24"></v-img>
              <a target="_blank" rel="noopener noreferrer" :href="callWhatsApp" class="pr-4 pl-1"> {{ contacWhatsapp }} </a>
              <v-row>
                <v-img src="@/assets/icons/whatsapp.png" max-width="24" min-width="24" max-height="24" min-height="24"></v-img>
                <a target="_blank" rel="noopener noreferrer" :href="callWhatsApp" class="pl-1"> {{ contacWhatsapp }} </a>
              </v-row>
            </v-layout>
            <v-layout class="pt-3" row wrap justify-start>
              <p class="pr-4">
                <v-icon color="grey">call</v-icon>
                {{ contactPhone }}
              </p>
              <p>
                <v-icon color="grey">mail</v-icon>
                <a :href="sendEmail"> {{ contacEmail }}</a>
              </p>
            </v-layout>
          </v-card-text>
          
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import apiState from '@/ilios.store'
import ImmobileCardFavorites from '@/components/Global/ImmobileCardFavorites.vue'

export default {
  name: 'FavoritesForm',

  props:{
    open:{
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    ImmobileCardFavorites
  },

  data: () => ({
    immobileFavoritesList: [],
    rules: {
      required: value => !!value || 'Campo Obrigatório.',
      maxSize: value => !value || value.size < 100000 || 'O tamanho máximo permitido do icone é de 100kb',
      notNegative: value => value > -1 || 'Valor do campo inválido.',
    },
  }),

  mounted() {

  },

  computed: {
    ...mapState('Company', {
      contactPhone: 'companyPhone',
      contacWhatsapp: 'companyWhatsApp',
      contacEmail: 'companyEmail',
      contacStreet: 'companyStreet',
      contacZip: 'companyZip',
      contacNumber: 'companyNumber',
      contacDistrict: 'companyDistrict',
      contacCity: 'companyCity',
      contacState: 'companyState',
    }),

    callWhatsApp() {
      return 'https://api.whatsapp.com/send?phone=' + this.contacWhatsapp;
    },

    sendEmail() {
      return 'mailto:' + this.contacEmail;
    },

  },

  watch: {
    open: function(){
      this.setImmobileFavorites()
    }
  },

  methods: {
    ...mapActions({
    }),

    ...mapGetters({
    }),

    setImmobileFavorites(){
      var favoritesKeys = this.$cookies.keys()
      this.immobileFavoritesList = []
      favoritesKeys.forEach(element => {
        this.immobileFavoritesList.push(this.$cookies.get(element))
      });
    },

    closeFavoritesForm(){
      this.$emit('closeFavoritesForm')
    },

  },
};
</script>